import { get, httpDelete, post } from "../../services/HttpService";

export class GstConfig {
  constructor(gstConfig = {}) {
    this.set(gstConfig);
  }

  static validations = {
    gstin: [
      { required: true, message: "GSTIN is required." },
      { pattern: '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$', message: "Please enter a valid GSTIN." },
    ],
    business_name: [{ required: true, message: "Business name is required." },],
  };

  /**
   * @memberof GstConfig
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`tax-payments/v1/internal/gst_config/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
  * @memberof GstConfig
  * @type API
  * @returns Promise
  */
  static create = (queryData = {}) => {
    return post(`tax-payments/v1/internal/gst_config/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof GstConfig
   * @type API
   * @returns Promise
   */
  delete = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return httpDelete(`tax-payments/v1/internal/gst_config/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof GstConfig
   * @type Setter Method
   * @takes GstConfig Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof GstConfig
   * @type Getter Method
   * @returns GstConfig
   */
  get = () => {
    return {
      id: this.uuid,
      gstin: this.gstin,
      business_name: this.business_name,
    };
  };
}
